import { render, staticRenderFns } from "./SingleClaim.vue?vue&type=template&id=45097e97&scoped=true&"
import script from "./SingleClaim.vue?vue&type=script&lang=js&"
export * from "./SingleClaim.vue?vue&type=script&lang=js&"
import style0 from "./SingleClaim.vue?vue&type=style&index=0&id=45097e97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45097e97",
  null
  
)

export default component.exports